import { Component, effect, input, signal } from '@angular/core';
import { AnnexesListComponent } from '@digiwall/goliath-core';
import { CustomerDocumentService, DocAnnexDto } from '@digiwall/goliath-documents/proxy';

@Component({
  standalone: true,
  selector: 'document-customer-project-annexes-list',
  templateUrl: './customer-project-document-annexes-list.component.html',
  styles: `
    :host {
      height: calc(100vh - 202px);
      display: flex;
      align-items: stretch;
      flex-direction: column;
    }
  `,
  imports: [AnnexesListComponent],
})
export class CustomerProjectDocumentAnnexesListComponent {
  customerProjectId = input.required<string>();

  protected annexes = signal<DocAnnexDto[]>(null);

  constructor(private documentService: CustomerDocumentService) {
    effect(() => {
      this.documentService
        .getAnnexesByCustomerProject(this.customerProjectId())
        .subscribeOnce(annexes => this.annexes.set(annexes));
    });
  }
}
